export default __webpack_public_path__ + "static/texture-bg-93a69e72fdb75fc95742d1cea63aceae.jpg";